/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-09-06 13:53:34
 * @LastEditors: linxi
 * @LastEditTime: 2025-11-19 11:00:26
 */
/* eslint-disable react/display-name */
import { QuestionCircleTwoTone } from '@ant-design/icons'
import {Button, Popover, TableColumnType} from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormat } from '../../models/datetime'

export const Columns = (onclick: (id:number) => void,startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      // fixed: 'left',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构名称',
      key: 'tenantName',
      width: '5em',
      align: 'center',
      render: (_, r) => (r?.tenantName ? r?.tenantName : '-'),
    },
    {
      title: '业务类型',
      key: 'businessType',
      width: '5em',
      align: 'center',
      render: (_, r) =>
        r?.businessType == 10
          ? '西医病历生成'
          : r?.businessType == 11
          ? '中医病历生成'
          : r?.businessType == 12
          ? '口腔病历生成'
          : r?.businessType == 20
          ? '处方病历审核'
          : r?.businessType == 30
          ? '病历推理'
          : '-',
    },
    {
      title: '接口耗时',
      key: 'apiCost',
      width: '5em',
      align: 'center',
      render: (_, r) => (r?.apiCost ? r?.apiCost : '-'),
    },
    {
      title: 'token数',
      key: 'token',
      width: '5em',
      align: 'center',
      render: (_, r) => (r?.token  && r?.token != -1 ? r?.token : '-'),
    },
    {
      title: '模型名称',
      key: 'modelName',
      width: '5em',
      align: 'center',
      render: (_, r) => (r?.modelName ? r?.modelName : '-'),
    },
    {
      title: '发生时间',
      key: 'createTime',
      width: '5em',
      align: 'center',
      render: (_, r) =>
        r?.createTime ? moment(r?.createTime).format(DateTimeFormat) : '-',
    },
    {
      title: '成功标志',
      key: 'createTime',
      width: '5em',
      align: 'center',
      render: (_, r) =>
          r?.successFlag == '1' ? '成功' :'失败'
    }, {
      title: "操作",
      align: "center",
      width:"4rem",
      // eslint-disable-next-line react/display-name
      render: (_, t) => {
        return (
            <>
              <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    onclick(t?.id)
                  }}
              >
                详情
              </Button>
            </>
        );
      },
    },
  ]
}
